import React from 'react';
import { MAX_FILE_SIZE_MB } from '../../constants';

export const LABEL = 'Select a file to upload';

export const HINT_TEXT = (
  <p className="vads-u-color--gray-medium vads-u-margin-top--0">
    You can upload a .pdf, .jpg, .jpeg, .png, .gif, .bmp, or .txt file. Each
    file should be no larger than {MAX_FILE_SIZE_MB} MB. Larger files may take
    longer to upload, depending on the internet connection.
  </p>
);
